import { render, staticRenderFns } from "./committees.vue?vue&type=template&id=ae22b74c&scoped=true&"
import script from "./committees.vue?vue&type=script&lang=js&"
export * from "./committees.vue?vue&type=script&lang=js&"
import style0 from "./committees.vue?vue&type=style&index=0&id=ae22b74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae22b74c",
  null
  
)

export default component.exports